import { render, staticRenderFns } from "./Statement-date.vue?vue&type=template&id=62e6146f"
import script from "./Statement-date.vue?vue&type=script&lang=js"
export * from "./Statement-date.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports